// services/api.js
import axios from 'axios';

// Read API URL from multiple sources for better compatibility
// 1. Build-time environment variable (development with .env)
// 2. Runtime config from nginx (production in Docker)
// 3. Default fallback
let apiBaseUrl = 'http://localhost:3001/api'; // Default fallback

// Check for build-time env var first (development mode)
if (process.env.REACT_APP_API_URL && !process.env.REACT_APP_API_URL.includes('${')) {
  apiBaseUrl = process.env.REACT_APP_API_URL;
}
// Check for runtime config (production/Docker mode)
else if (window.__RUNTIME_CONFIG__?.API_URL && !window.__RUNTIME_CONFIG__.API_URL.includes('${')) {
  apiBaseUrl = window.__RUNTIME_CONFIG__.API_URL;
}

console.log('[API Config] Using API base URL:', apiBaseUrl);

const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;